import { Injectable } from '@angular/core';

@Injectable()
export class ConsoleService {
	warn(message: string) {
		console.warn(message);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/libs/@ng-select/ng-select/console.service.ts